import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppFormsModule } from '../../../forms/forms.module';
import { MaterialModule } from '../../../material.module';
import { SharedModule } from '../../../shared/shared.module';
import { GrocySharedModule } from '../shared/shared.module';
import { GrocyActionsComponent } from './components/actions/actions.component';
import { GrocyCalendarComponent } from './components/calendar/calendar.component';
import { GrocyDashboardComponent } from './components/dashboard/dashboard.component';
import { GrocyQuickActionDialogComponent } from './components/quick-action-dialog/quick-action-dialog.component';
import { GrocyRecentStockLogsComponent } from './components/recent-stock-logs/recent-stock-logs.component';
import { GrocyRegisterShoppingDialogComponent } from './components/register-shopping-dialog/register-shopping-dialog.component';
import { GrocyStockLookupDialogComponent } from './components/stock-lookup-dialog/stock-lookup-dialog.component';
import { TimeModule } from '../../time/time.module';
import { WeatherModule } from '../../weather/weather.module';

@NgModule({
  declarations: [
    GrocyActionsComponent,
    GrocyCalendarComponent,
    GrocyDashboardComponent,
    GrocyQuickActionDialogComponent,
    GrocyRecentStockLogsComponent,
    GrocyRegisterShoppingDialogComponent,
    GrocyStockLookupDialogComponent,
  ],
  imports: [
    AppFormsModule,
    CommonModule,
    FormsModule,
    GrocySharedModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    TimeModule,
    WeatherModule,
  ],
  exports: [GrocyActionsComponent, GrocyCalendarComponent],
})
export class GrocyDashboardModule {}
